export enum MSRSegment {
  Saturday = "Saturday",
  Sunday = "Sunday",
}
